module.exports = __webpack_public_path__ + "img/heart-white.82f5190a.svg";